import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import browserHistory from 'react-router/lib/browserHistory';
import configureStore from './Stores';
import { routes } from './Routes';
import { syncHistoryWithStore } from 'react-router-redux';
import Router from 'react-router/lib/Router';
import Token from './Token';

const store = configureStore();
const history = syncHistoryWithStore(browserHistory, store);

history.listen(location => {
    const { pathname } = location;

    const token = Token.validate(
        sessionStorage.getItem('token')
    );

    if(pathname.indexOf('profile') > 0 && !token) {
        history.push('/')
    }
});

render(
    <Provider store={ store }>
         <Router history={ history } routes={ routes }/>
    </Provider>,
    document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js